import { Ua } from './partial/Ua';
import { Menu } from './partial/Menu';
import { Header } from './partial/Header';
import { Anchor } from './partial/Anchor';
import { Kv } from './partial/Kv';
import { Sticky } from './partial/sticky';
import { Bg } from './partial/Bg';
import { Form } from './partial/Form';

// polyfill forEach for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
   NodeList.prototype.forEach = Array.prototype.forEach;
}

new Ua();
new Menu();

if(document.querySelector('.page-top')) {
   new Header();
   new Anchor();
   new Kv();
   new Sticky();
   new Bg();
   new Form();
}